import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import PABReplanningService from '../../../../services/PABReplanningService';
import { translate, isNullOrEmpty, downloadFile, showMessageToastCustom, closeCollapsible, formatData, enumText } from '../../../../utils/util';
import { Breadcrumbs, Button, Input, Select, Collapsible, InfiniteScroll } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { ENUMS } from '../../../../utils/constants';

const ListReportPicking = (props) => {
    const getStatus = (value) => enumText(ENUMS.eOrderPabStatus, value);
    const [currentPage, setCurrentPage] = useState(0);
    const [data, setData] = useState([]);
    const [orders, setOrders] = useState();
    const [filter, setFilter] = useState(
        {
            dateStart: "",
            dateEnd: "",
            orderCode: "",
            orderItemCode: "",
            partNumber: "",
            status: [1, 2, 3, 4, 5, 6],
            supplierCode: "",
        });

    useEffect(() => {
        if (orders?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(orders.items);
            } else {
                setData((prevState) => ([...prevState, ...orders.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [orders?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport") && validateMonth()) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getOrders(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, (data) => {
                setOrders(data);
                if (click) {
                    closeCollapsible("collapsible2")
                }
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const validateRequired = () => {
        if (!isNullOrEmpty(filter.orderCode) || !isNullOrEmpty(filter.orderItemCode) || !isNullOrEmpty(filter.orderGroupId)) {
            return false;
        }
        return true;
    }

    const validateMonth = () => {
        var data1 = new Date(filter.dateStart);
        var data2 = new Date(filter.dateEnd);
        var total = (data2.getFullYear() - data1.getFullYear()) * 12 + (data2.getMonth() - data1.getMonth());
        if (total > 12) {
            showMessageToastCustom(translate('warning', 'general'), "Permitido apenas período de 12 Meses", 8000, 'mdi mdi-alert-circle-outline red-text');
            return false;
        }
        return true;
    }

    const downloadReport = () => {
        props.getReport(filter, (data) => {
            downloadFile(data, `ReportChamadas${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    return (
        <div>
            <Breadcrumbs id="transmissionTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: 'Relatório' }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="collapsible2"
                        header={translate('expedition:picking.filter')}
                        body={
                            <>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            defaultValue={filter.dateStart}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="dateStart"
                                            name="dateStart"
                                            onChange={onChange}
                                            required={validateRequired()}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.dateEnd}
                                            type="date"
                                            label={translate('change-location:endDate')}
                                            id="dateEnd"
                                            name="dateEnd"
                                            onChange={onChange}
                                            required={validateRequired()}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="orderCode"
                                            name='orderCode'
                                            label={translate('line-picking:transmission.call')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="partNumber"
                                            name='partNumber'
                                            label={translate('line-picking:linepicking.partnumber')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s6">
                                        <Input
                                            id="supplierCode"
                                            name='supplierCode'
                                            label={translate('expedition:picking.supplier')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <Select
                                            id="status"
                                            name="status"
                                            display="description"
                                            defaultValue={filter.status || ''}
                                            change={(event) => {
                                                filter.status = !isNullOrEmpty(event.currentTarget.value)
                                                    ? [event.currentTarget.value] : filter.status = [1, 3];
                                                setFilter({ ...filter })
                                            }}
                                            label={`Status - ${translate('general:choose-one-option')}`}
                                            data={[{ id: ENUMS.eOrderPabStatus.Waiting.value, text: ENUMS.eOrderPabStatus.Waiting.text, },
                                            { id: ENUMS.eOrderPabStatus.Finished.value, text: ENUMS.eOrderPabStatus.Finished.text }
                                            ]} />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </>
                        }
                    />
                    {
                        data.length > 0 && <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text="Gerar Relatorio" />
                        </div>
                    }
                </div>
                <div id="listPab">
                    <InfiniteScroll
                        page={orders?.totalPages}
                        hasMore={currentPage < orders?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item) => {
                                return (
                                    <div key={`o-${item.orderCode}`} >
                                        <span className="title sixth-text-color">
                                            {item?.partNumberCode}-{item?.partNumberDescription}
                                        </span>

                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="title sixth-text-color">
                                                {item?.location}
                                            </span>
                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="title sixth-text-color">
                                                {item?.pabOrderCode}
                                            </span>
                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                                {item?.supplierCode}-{item?.supplierName}
                                            </span>
                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                                {translate('line-picking:linepicking.amount')}: {(item?.quantity)}
                                            </span>

                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                                {translate('line-picking:linepicking.mdr')}:  {item.mdrType}
                                            </span>
                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                                {translate('physical-confirmation:date')}:  {formatData(item.createdOn)}
                                            </span>
                                        </div>
                                        <div className="col s12 " style={{ padding: '0px' }}>
                                            <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                                                {translate('line-picking:linepicking.status')}:  {getStatus(item.status)}
                                            </span>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrders: (filter, pagination, callback) => {
            dispatch(PABReplanningService.getOrders(filter, pagination, callback));
        },
        getReport: (filter, callback) => {
            dispatch(PABReplanningService.getReport(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListReportPicking)));
